(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stinebe-laundry-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stinebe-laundry-order')) {
    customElements.define('stinebe-laundry-order', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        queueMicrotask(() => {
          if (!this.isConnected) return;
          try { this.initialize(); } catch { this.hidden = true; }
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.closest('product-info')?.classList.remove('sb-laundry-ready');
      }
      initialize() {
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.strings = this.config.strings;
        this.money = new Intl.NumberFormat('nb-NO', { style: 'currency', currency: this.config.currency || 'NOK', minimumFractionDigits: 0, maximumFractionDigits: 2 });
        this.form = this.querySelector('form');
        this.rows = this.querySelector('[data-rows]');
        this.controls = this.querySelector('.sb-laundry__controls');
        this.submitButton = this.querySelector('[data-submit]');
        this.error = this.querySelector('[data-error]');
        this.checkCart = this.querySelector('[data-check-cart]');
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const add = event.target.closest('[data-add]');
          if (add) this.addRow(add.dataset.add);
          if (event.target.closest('[data-another]')) this.addRow(this.lastKind || 'symbol');
          const remove = event.target.closest('[data-remove]');
          if (remove) {
            const row = remove.closest('[data-kind]');
            const next = row.nextElementSibling || row.previousElementSibling;
            row.remove();
            this.update();
            (next?.querySelector('select, input, button') || this.querySelector('[data-add]')).focus();
          }
        }, options);
        const update = () => this.update();
        this.addEventListener('input', update, options);
        this.addEventListener('change', update, options);
        this.form.addEventListener('submit', event => this.submit(event), options);
        window.addEventListener('pageshow', event => {
          if (event.persisted) { this.pending = false; this.controls.disabled = false; this.submitButton.textContent = this.strings.add_all; this.update(); }
        }, options);
        this.update();
        this.hidden = false;
        this.closest('product-info')?.classList.add('sb-laundry-ready');
      }
      getRows() { return [...this.rows.children]; }
      addRow(kind) {
        if (this.pending) return;
        const template = this.querySelector(`[data-template="${kind}"]`);
        if (!template) return;
        const row = template.content.firstElementChild.cloneNode(true);
        this.rows.append(row);
        this.lastKind = kind;
        this.update();
        row.querySelector('select, input').focus();
      }
      variantFor(row) {
        if (row.dataset.kind === 'sheet') return this.config.variants.find(variant => variant.options[0] === 'Komplett ark som på bildet');
        if (row.dataset.kind === 'text') return this.config.variants.find(variant => variant.options[0] === 'Kun tekst - ingen symbol');
        const temperature = row.querySelector('[data-field="temperature"]').value;
        const label = row.querySelector('[data-field="label"]').value;
        return this.config.variants.find(variant => variant.options[0] === temperature && variant.options[1] === label);
      }
      update() {
        let total = 0;
        let labels = 0;
        let sheets = 0;
        let unavailable = false;
        const rows = this.getRows();
        rows.forEach((row, index) => {
          row.querySelector('[data-number]').textContent = `${this.strings.item} ${index + 1}`;
          const type = row.dataset.kind;
          const label = row.querySelector('[data-field="label"]');
          const custom = row.querySelector('[data-field="custom"]');
          if (type === 'symbol') {
            const show = label.value === 'Egen tekst';
            row.querySelector('[data-custom]').hidden = !show;
            custom.disabled = !show;
            custom.required = show;
          }
          if (custom) custom.setCustomValidity(!custom.disabled && custom.value.length > 0 && !custom.value.trim() ? this.strings.enter_text : '');
          const variant = this.variantFor(row);
          const fallback = variant || this.config.variants.find(item => type === 'symbol' ? /^\d+$/.test(item.options[0]) : type === 'sheet' ? item.options[0] === 'Komplett ark som på bildet' : item.options[0] === 'Kun tekst - ingen symbol');
          const quantity = row.querySelector('[data-field="quantity"]');
          quantity.min = variant?.min || 1;
          quantity.step = variant?.step || 1;
          if (variant?.max != null) quantity.max = variant.max;
          else quantity.removeAttribute('max');
          const count = Number.isSafeInteger(quantity.valueAsNumber) && quantity.valueAsNumber > 0 ? quantity.valueAsNumber : 0;
          total += (fallback?.price || 0) * count;
          if (type === 'sheet') sheets += count;
          else labels += count;
          row.querySelector('[data-price]').textContent = this.money.format((fallback?.price || 0) * count / 100);
          const missing = type === 'symbol' && row.querySelector('[data-field="temperature"]').value && label.value && !variant;
          const soldOut = Boolean(missing || (variant && !variant.available));
          row.querySelector('[data-unavailable]').hidden = !soldOut;
          unavailable = unavailable || soldOut;
        });
        const counts = [];
        if (labels) counts.push(`${labels} ${labels === 1 ? this.strings.label_singular : this.strings.label_plural}`);
        if (sheets) counts.push(`${sheets} ${this.strings.sheet_count}`);
        this.querySelector('[data-count]').textContent = counts.join(' · ') || this.strings.no_items;
        this.querySelector('[data-total]').textContent = this.money.format(total / 100);
        this.querySelector('[data-empty]').hidden = rows.length > 0;
        this.querySelector('[data-another]').hidden = rows.length === 0;
        this.submitButton.disabled = Boolean(this.pending || !rows.length || unavailable);
      }
      async submit(event) {
        event.preventDefault();
        if (this.pending) return;
        this.update();
        if (!this.form.reportValidity()) return;
        const rows = this.getRows();
        if (!rows.length) return;
        const items = [];
        for (const row of rows) {
          const variant = this.variantFor(row);
          if (!variant?.available) return;
          const quantity = row.querySelector('[data-field="quantity"]').valueAsNumber;
          const type = row.dataset.kind;
          const properties = {};
          properties[this.strings.property_type] = this.strings[`${type}_type`];
          if (type === 'symbol') {
            properties[this.strings.temperature] = `${row.querySelector('[data-field="temperature"]').value} °C`;
            const label = row.querySelector('[data-field="label"]').value;
            properties[this.strings.label_text] = label === 'Egen tekst' ? row.querySelector('[data-field="custom"]').value.trim() : label;
          } else if (type === 'text') {
            properties[this.strings.label_text] = row.querySelector('[data-field="custom"]').value.trim();
          }
          const matching = items.find(item => item.id === variant.id && JSON.stringify(item.properties) === JSON.stringify(properties));
          if (matching) matching.quantity += quantity;
          else items.push({ id: variant.id, quantity, properties });
        }
        this.pending = true;
        this.controls.disabled = true;
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.strings.adding;
        this.error.hidden = true;
        try {
          const response = await fetch(this.config.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok || result.status || !result.items?.length) throw new Error('cart_add_failed');
          window.location.assign(this.config.cartUrl);
        } catch {
          this.error.textContent = this.strings.cart_error;
          this.error.hidden = false;
          this.checkCart.hidden = false;
          this.checkCart.focus();
          this.submitButton.textContent = this.strings.check_cart;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stinebe-media-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stinebe-media-consent')) {
  class StinebeMediaConsent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.addEventListener('change', (event) => this.handleChange(event));
      this.updateVisibility();
    }

    get consentValue() {
      return this.querySelector('input[type="radio"]:checked')?.value || '';
    }

    get publishDate() {
      return this.querySelector('[data-publish-date]')?.value || '';
    }

    isYes(value) {
      return value === 'Ja – med personalisering' || value === 'Ja – uten personalisering';
    }

    handleChange(event) {
      if (!event.target.matches('input[type="radio"], input[type="date"]')) return;

      if (event.target.matches('input[type="radio"]')) {
        if (!this.isYes(this.consentValue)) {
          const dateInput = this.querySelector('[data-publish-date]');
          if (dateInput) dateInput.value = '';
        }
        this.updateVisibility();
      }

      this.save();
    }

    updateVisibility() {
      const giftOptions = this.querySelector('[data-gift-options]');
      if (giftOptions) giftOptions.hidden = !this.isYes(this.consentValue);
    }

    setCheckoutDisabled(disabled) {
      document.querySelectorAll('button[name="checkout"]').forEach((button) => {
        if (disabled) {
          if (!button.disabled) {
            button.dataset.stinebeConsentDisabled = 'true';
            button.disabled = true;
          }
        } else if (button.dataset.stinebeConsentDisabled === 'true') {
          button.disabled = false;
          delete button.dataset.stinebeConsentDisabled;
        }
      });
    }

    setStatus(message, isError) {
      const status = this.querySelector('[data-status]');
      if (!status) return;
      status.textContent = message || '';
      if (isError) {
        status.dataset.error = 'true';
      } else {
        delete status.dataset.error;
      }
    }

    applyState(consent, publishDate) {
      this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.checked = radio.value === consent;
      });

      const dateInput = this.querySelector('[data-publish-date]');
      if (dateInput) dateInput.value = publishDate || '';
      this.updateVisibility();
    }

    async save() {
      const consent = this.consentValue;
      const publishDate = this.isYes(consent) ? this.publishDate : '';

      this.setCheckoutDisabled(true);
      this.setAttribute('aria-busy', 'true');
      this.setStatus('', false);

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Publisering av produkt': consent,
              'Ikke publiser før': publishDate
            }
          })
        });

        if (!response.ok) throw new Error('Cart attribute update failed');

        const cart = await response.json();
        if (cart?.errors) throw new Error('Cart attribute update failed');

        document.querySelectorAll('stinebe-media-consent').forEach((element) => {
          if (typeof element.applyState === 'function') {
            element.applyState(consent, publishDate);
          }
        });

        this.setStatus(this.dataset.savedMessage || '', false);
      } catch (error) {
        this.setStatus(this.dataset.errorMessage || '', true);
      } finally {
        this.removeAttribute('aria-busy');
        this.setCheckoutDisabled(false);
      }
    }
  }

  customElements.define('stinebe-media-consent', StinebeMediaConsent);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stinebe-name-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stinebe-name-preview')) {
    customElements.define('stinebe-name-preview', class extends HTMLElement {
      connectedCallback() {
        const input = this.parentElement?.querySelector('input[name="properties[Navn på produktet]"]');
        const product = this.closest('product-info');
        if (!input || !product) return;

        this.listeners?.abort();
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        const samples = [...this.querySelectorAll('.stinebe-name-preview__sample')];
        const cards = this.querySelectorAll('[data-name-preview-face]');

        const showName = () => {
          const name = input.value.trim() || 'Tobias';
          for (const sample of samples) {
            sample.textContent = name;
            sample.style.fontSize = '';
            const availableWidth = sample.parentElement.clientWidth - 10;
            if (availableWidth > 0 && sample.scrollWidth > availableWidth) {
              const fontSize = parseFloat(getComputedStyle(sample).fontSize);
              sample.style.fontSize = Math.floor(fontSize * availableWidth / sample.scrollWidth) + 'px';
            }
          }
        };

        const highlightSelection = () => {
          const selected = product.querySelector(
            'variant-selects input[data-option-name="Skrifttype"]:checked, ' +
              'variant-selects select option[data-option-name="Skrifttype"]:checked, ' +
              'input[name="properties[Skrifttype]"]:checked'
          )?.value;
          for (const card of cards) {
            card.setAttribute('aria-current', String(card.dataset.namePreviewFace === selected));
          }
        };

        input.addEventListener('input', showName, options);
        product.addEventListener('change', highlightSelection, options);
        this.hidden = false;
        showName();
        highlightSelection();

        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(showName);
        this.resizeObserver.observe(this);
        document.fonts.ready.then(() => {
          if (this.isConnected) showName();
        });
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
